import { useQuery } from '@tanstack/react-query';

// common
import { KEYS_QUERY } from 'common/constants';
import useService from 'common/hook/useService';
import { handleException } from 'modules/account/detail/helpers/utils';

/**
 * Lấy roles của tài khoản đang được chỉnh sửa.
 * Gọi UserManagementController_getUserRoles -> GET /management/user/:userId/role
 */
const useGetAccountRoles = (userId: string) => {
  const service = useService();

  return useQuery({
    queryKey: [KEYS_QUERY.accountRoles, userId],
    queryFn: async () => {
      try {
        if (!service || !userId) return null;

        const res = await service.UserManagementController_getUserRoles({
          params: { userId },
        });
        return res;
      } catch (error) {
        handleException(error);
      }
    },
    staleTime: 0,
  });
};

export default useGetAccountRoles;
